import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { AvatarTypes } from '@mode/shared/contract-common';

@Component({
  selector: 'mode-user-email',
  templateUrl: './user-email.component.html',
  styleUrls: ['./user-email.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserEmailComponent {
  @Input() name!: string;
  @Input() email!: string;
  @Input() avatar!: AvatarTypes.Avatar;
  @Input() showCloseBtn = false;
  @Input() isExternalDomain = false;
  @Input() externalSharingEnabled = false;

  @Output() closeBtnClicked = new EventEmitter();

  externalBadgeTooltipText = 'This subscriber is outside of your Mode Workspace';
  externalErrorTooltipText =
    'Members outside your Workspace can no longer subscribe to this schedule. To use this email address, authorize the email domain or reenable External Sharing for this Report.';
}
